/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
import { useState, useContext, useEffect } from 'react';

import axios from 'axios';

import config from '../../../../../config';
import fileReader from '../../../../../core/utils/fileReader';
import fileSaver from '../../../../../core/utils/fileSaver';
import { GeneralContext } from '../../../../../core/app-context/GeneralContext';
import { Translator } from '../../../../../core/i18n/translator';
import AuthService from '../../../../../core/auth/AuthService';

export function useExportOrderCsv() {
  const { setLoading, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const ordersExportedSuccessMessage = Translator('order.tracking.EXPORTED');

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading]);

  async function exportOrdersCsv({ storeId, filters }) {
    setIsLoading(true);
    try {
      const response = await axios.post(
        config.exportOrdersUrl,
        { storeId, filters },
        {
          responseType: 'blob',
          headers: {
            'Content-Type': 'text/csv',
            Authorization: `Bearer ${AuthService.getToken()}`,
          },
        },
      );
      const data = new Blob([response.data]);
      fileSaver(
        data,
        `reversa_orders_${new Date().toLocaleDateString('pt-BR')}.csv`,
      );
      setSuccessMessage(ordersExportedSuccessMessage);
    } catch (e) {
      if (e.response) {
        try {
          const { data } = e.response;
          // As endpoint returns a blob, we must convert the file to access the error message
          const file = await fileReader(data);
          const { error } = JSON.parse(file);
          setErrorMessage(error);
        } catch (readError) {
          setErrorMessage('Erro interno. Tente novamente.');
        }
      } else {
        setErrorMessage('Erro interno. Tente novamente.');
      }
    } finally {
      setIsLoading(false);
    }
  }

  return {
    exportOrdersCsv,
    loading: isLoading,
  };
}
